import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { ChatService } from '@gallaghercp/core-chat';
import { AnalyticsService } from '@gallaghercp/core-frontend';
import { Subscription } from 'rxjs';

@Component({
    selector: 'core-block-chat',
    template: `
        <core-chat
            [botName]="botName"
            [startingMessage]="startingMessage | translate"
            [demoMode]="demoMode ?? false"
        ></core-chat>
    `,
    standalone: false,
})
export class BlockChatComponent implements OnInit, OnDestroy {
    private chat = inject(ChatService);
    private analytics = inject(AnalyticsService);

    @Input() botName!: string;
    @Input() startingMessage!: string;
    @Input() demoMode?: boolean;

    private eventSubscription!: Subscription;

    ngOnInit() {
        this.eventSubscription = this.chat.eventEmitter.subscribe((event: any): void => {
            const properties: any = {
                eventType: 'PageAction',
                category: event.category,
                label: event.label,
                value: event.value,
                message: event.message ?? event.response ?? undefined,
                bot: this.botName,
            };

            try {
                this.analytics.trackEvent(event.action, properties);
            } catch (e) {
                console.warn(e);
            }
        });
    }

    ngOnDestroy() {
        this.eventSubscription.unsubscribe();
    }
}
